import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage         from './pages/LandingPage';
import Login               from './pages/Login';
import Dashboard           from './pages/Dashboard';
import Exampage            from './pages/Exampage';
import ResultPage          from './pages/ResultPage';
import CongratulationsPage from './pages/CongratulationsPage';
import KeepGoingPage       from './pages/KeepGoingPage';
import RecruiterDashboard  from "./pages/recuriter-dashoard";
import CandidatesPage      from "./pages/CandidatesPage";
import Sections            from "./pages/Sections";
import QuestionBank        from "./pages/QuestionBank";
import ExamManagement from './pages/ExamManagement';
import DrivePage from './pages/DrivePage';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import RecruiterAnalytics  from './pages/RecruiterAnalytics';
import { getStoredTokenForRole } from './utils/authStorage';

// Redirects to /login if no token found in localStorage
function PrivateRoute({ children, role }) {
  return getStoredTokenForRole(role) ? children : <Navigate to="/login" replace />;
}

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        {/* Public Routes */}
        <Route path="/"                 element={<LandingPage />} />
        <Route path="/login"            element={<Login />} />

        {/* Candidate Routes */}
        {/* Candidate Routes */}
        <Route path="/dashboard"       element={<PrivateRoute role="candidate"><div className="candidate-view"><Dashboard /></div></PrivateRoute>} />
        <Route path="/exam"            element={<PrivateRoute role="candidate"><div className="candidate-view"><Exampage /></div></PrivateRoute>} />
        <Route path="/result"          element={<PrivateRoute role="candidate"><div className="candidate-view"><ResultPage /></div></PrivateRoute>} />
        <Route path="/congratulations" element={<PrivateRoute role="candidate"><div className="candidate-view"><CongratulationsPage /></div></PrivateRoute>} />
        <Route path="/keep-going"      element={<PrivateRoute role="candidate"><div className="candidate-view"><KeepGoingPage /></div></PrivateRoute>} />

        {/* Recruiter Routes */}
        <Route path="/recruiter"       element={<PrivateRoute role="recruiter"><RecruiterDashboard /></PrivateRoute>} />
        <Route path="/drives"          element={<PrivateRoute role="recruiter"><DrivePage /></PrivateRoute>} />
        <Route path="/candidates"      element={<PrivateRoute role="recruiter"><CandidatesPage /></PrivateRoute>} />
        <Route path="/sections"        element={<PrivateRoute role="recruiter"><Sections /></PrivateRoute>} />
        <Route path="/question-bank"   element={<PrivateRoute role="recruiter"><QuestionBank /></PrivateRoute>} />
        <Route path="/exam-management" element={<PrivateRoute role="recruiter"><ExamManagement /></PrivateRoute>} />
        <Route path="/superadmin"      element={<PrivateRoute role="superadmin"><SuperAdminDashboard /></PrivateRoute>} />
        <Route path="/superadmin/sections" element={<PrivateRoute role="superadmin"><Sections /></PrivateRoute>} />
        <Route path="/superadmin/questionbank" element={<PrivateRoute role="superadmin"><QuestionBank /></PrivateRoute>} />
        <Route path="/superadmin/question-bank" element={<PrivateRoute role="superadmin"><QuestionBank /></PrivateRoute>} />
        <Route path="/analytics"       element={<PrivateRoute role="recruiter"><RecruiterAnalytics /></PrivateRoute>} />
        {/* Catch all unknown URLs → redirect to home */}
        <Route path="*"                 element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
